import React from 'react'
import UserProfileWithRating from '../../UserProfileWithRatings'
import bold from '../../../assets/img/landing/bold.jpg'
import sh from '../../../assets/img/landing/sh.jpg'
import od from '../../../assets/img/landing/od.jpg'


const comments = [
  {
    userImage: bold,
    userName: 'Bold Tovuu',
    userTitle: ' “ЯРИХ ӨНЦӨГ” нэвтрүүлгийн хөтлөгч',
    userDescription:
      'Энэ клиникийн санал болгож буй GenomeCheckH шинжилгээг 2 гэр бүлийн 4 үүлээ өгсөн юм. Мэдээж өгөхөөсөө өмнө мэргэжлийн эмч нараас асууж зөвлөгөө авсан. “ЯРИХ ӨНЦӨГ” нэвтрүүлгийн хөтлөгчийн хувьд УИХГ, Хүний гавьяат эмч, ХӨСҮТ дарга асан Ж.Чинбүрэн эмчээс энэ тестийн шинжлэх ухаан үндэстэй эсэхийг асуун тодруулсны дараа орсон юм. Ер нь аливаа хорт хавдар удамших өндөр магадлалтайг Анагаахын шинжлэх ухаан өнөөдөр батлаад буй билээ. Амны арчдасаас жаахан био дээж аваад оношилгоо хийгдээд 14 хоногийн дараа хариуг чамд хэлдгийн билээ. Ямар хавдраар өвдөх магадлалтайгаа мэдчихнэ гэдэг сэтгэл амар юм байна. Маш хэрэгтэй үйлчилгээ, лав бид 4т таалагдсан.',
    star: 5
  },
  {
    userImage: od,
    userName: 'Odmunkh Bayar',
    userTitle: 'Дата секьюрити ХХК, Захирал',
    userDescription:
      'Селл Клиник эмнэлгийн танилцуулсан хүний эсийн эмчилгээний талаар анх сонсоод гайхахын зэрэгцээ, маш их сонирхсон. Миний хувьд хүний ген удамшдаг, цаашлаад удмын мэдээллийг дамжуулдаг гэсэн бодолтой байдаг. Үүнийгээ дагаад сайн эс удамшихаас гадна, муу эс ч удамших боломжтой гэж боддог. Шинжилгээ өгөхөөс өмнө тус Лаборатори нь эрүүл ахуйн өндөр түвшинд хамгаалагдсан болохыг судалж танилцаад шийдвэрээ гаргасан. Мөн шинжлэх ухаан өндөр хөгжсөн Солонгосын алдартай лабораторитой хамтран уг шинжилгээг хийж байгаа нь баталгаатай хариу гарж байгаа гэдэгт итгэсэн. Иймээс энэхүү GenomeCheck H 11 төрлийн хавдрын эрсдэлийг шинжилгээг өгсөн.',
    star: 5
  },
  {
    userImage: sh,
    userName: 'Ш.Мухамеджан',
    userTitle: 'Үйлдвэрийн менежер',
    userDescription:
      'Саяхан Хавдартай тэмцэх дэлхийн өдрийг тохиолдуулан хавдрын өвчлөлтэй холбоотой маш олон гадаад, дотоодын тоон баримт, статистик мэдээлэл хөвөрч эхэлсэн. Тухайн үед надад ямар нэгэн эрсдэлт хүчин зүйл, хавдрын эрт үед явж байгаа янз бүрийн өвчлөл байдаг юм биш байгаа гэсэн бодол хэд хоног хөвөрсөн. Яг тэр үед Одхүү докторын Геном чек буюу 13 төрлийн хавдрын илрүүлэг, эрсдэлт хүчин зүйлийг илрүүлэх шинжилгээ хийж эхэлсэн талаар мэдээлэл олж үзээд тус шинжилгээг хийлгэхээр шийдвэрлэсэн. Шинжилгээний хариу 14-15 хоног болоод надад мейлээр ирсэн. Ирээдүйд ямар эрхтний хавдраар өвчлөх өндөр эрсдэл, магадлалтайг мэдэж авсан. Одоо сэтгэл амар, бас ирээдүйд ямар эрсдэлт хүчин зүйл, ямар эрхтний хавдраар өвчлөх эрсдэлтэйг мэдэж авна гэдэг чинь урьдчилан сэргийлж, амьдралын хэв маягаа өөрчлөх, зарим хорт зуршлаас салахад шууд нөлөөлнө гэж бодож байна. Сайхан үйлчилгээ нэвтрүүлж, дэлхийн хөгжилтэй хөл нийлүүлэн алхаж буй залуучууддаа баярлалаа. Ажлын амжилт хүсье.',
    star: 5
  }
]

const CustomerSatisfactionSection = () => {
  return (
    <section
      id='about'
      className='h-[30vh]  rounded-2xl mt-5 mobile:h-[120vh]'
    >
      <div className='flex flex-row justify-between h-[40px] '>
        <div className='flex flex-row items-center text-[#215998] mobile:text-[10px] '>
          <p className=''>05 / 06</p>
          <p className='ml-8 text-[#398292] gap-2 '>|</p>
          <p className='ml-8 uppercase text-[36px] font-bold mobile:text-[16px] text-[#398292] tablet:text-[28px] tablet:text-[#215998]'>
          Үйлчлүүлэгчийн сэтгэл ханамж
          </p>
        </div>
      </div>
      <div className='flex flex-row mt-10 justify-between mobile:mt-[0px] mobile:flex-col mobile:p-5 '>
        {comments.map((user, index) => (
          <UserProfileWithRating
            key={index}
            userImage={user.userImage}
            userName={user.userName}
            userTitle={user.userTitle}
            userDescription={user.userDescription}
            star={user.star}
          />
        ))}
      </div>
    </section>
  )
}

export default CustomerSatisfactionSection
